/** An event about to be posted: the catalogued wire name and its final properties. */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- the properties are whatever the catalogued event sends
export type InterceptedEvent = { event: string; properties: Record<string, unknown> };

/** Returns true when it took the event, which is then not posted to ui_api. */
export type EventInterceptor = (event: InterceptedEvent) => boolean;

let interceptor: EventInterceptor | null = null;

/**
 * Lets an embedded surface take over delivery of every event, e.g. to forward them to the host page that
 * owns analytics. Pass `null` to restore posting to ui_api. One interceptor at a time.
 */
export function setEventInterceptor(next: EventInterceptor | null): void {
  interceptor = next;
}

export function interceptEvent(event: InterceptedEvent): boolean {
  return interceptor?.(event) ?? false;
}
